import { Injectable, inject, signal } from '@angular/core';
import { ThemeService } from './theme.service';

/**
 * Partner-Embed-Kontext (z. B. LTO-Pilot): Wird gesetzt, wenn der /go-Flow mit
 * einem partner-Queryparam gestartet wurde. Solange aktiv, rendert die App das
 * Minimal-Layout ohne Sidebar/App-Navigation, damit im iframe eines Partners
 * nur die Arbeitsfläche (Editor/Ergebnis) sichtbar ist.
 *
 * Ablage in sessionStorage: überlebt interne Navigationen und Reloads im
 * selben Tab/iframe, leakt aber nicht in andere Tabs oder Origins.
 */
@Injectable({ providedIn: 'root' })
export class PartnerEmbedService {
  private readonly storageKey = 'kk_partner_embed';
  private readonly themeService = inject(ThemeService);

  readonly partner = signal<string | null>(this.read());

  constructor() {
    // Reload im Embed: Flag liegt schon in sessionStorage -> Light-Mode direkt erzwingen
    if (this.partner()) {
      this.themeService.setTheme('light');
    }
  }

  activate(partner: string): void {
    try {
      sessionStorage.setItem(this.storageKey, partner);
    } catch {
      // sessionStorage nicht verfügbar (z. B. blockierte Cookies) – Flag lebt dann nur im Signal
    }
    this.partner.set(partner);
    // Partner-Seiten (LTO) sind hell – dunkles Modul im weißen Artikel wirkt fremd
    this.themeService.setTheme('light');
  }

  isEmbed(): boolean {
    return !!this.partner();
  }

  private read(): string | null {
    try {
      return sessionStorage.getItem(this.storageKey);
    } catch {
      return null;
    }
  }
}
